import { Box, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BlankPage } from "../../components/BlankPage/BlankPage";
import { ErrorComponent } from "../../components/ErrorComponent/ErrorComponent";
import ImportantUpdatesBanner from "../../components/ImportantUpdatesBanner/ImportantUpdatesBanner";
import { AccountCard } from "../../components/shared/AccountCard/AccountCard";
import InactiveAccountBanner from "../../components/shared/InactiveAccountBanner/InactiveAccountBanner";
import { LinkingWaitMessage } from "../../components/shared/LinkingWaitMessage/LinkingWaitMessage";
import { NeedHelpCard } from "../../components/shared/NeedHelpCard/NeedHelpCard";
import {
  FIBERFIRST_ACQUIRED_COMPANY,
  FIBERFIRST_BANNER_KEY,
  HOMEPAGE_BANNER_SHARE_ZIPLY_BUTTON,
  WELCOME_BACK,
} from "../../Constants/constants";
import { TrackOrder } from "../../Pages/Home/Components/TrackYourOrder/TrackYourOrder";
import { setCheckRouterTypeError } from "../../Redux/Slices/NetworkStatusSlice";
import {
  getBannerMessageByKey,
  getFlags,
  readCookie,
  splitMessageBybraces,
} from "../../Services/helper";
import { PageGrid, StickyBox, StyledCard, WelcomeHeading } from "../../Styles/GlobalStyles";
import { Theme } from "../../Styles/GlobalTheme";
import { EquipmentReturnPendingBanner } from "./Components/EquipmentReturnPendingBanner/EquipmentReturnPendingBanner";
import { FiberFirstBanner } from "./Components/FiberFirstBanner/FiberFirstBanner";
import { HomepageNewBanners } from "./Components/HomepageNewBanners/HomepageNewBanners";
import NetworkHealthBanner from "./Components/NetworkTest/NetworkHealthBanner";
import NetworkTest from "./Components/NetworkTest/NetworkTest";
import { TroubleTicketStatus } from "./Components/TroubleTicketStatus/TroubleTicketStatus";
import { AccountSummaryCard } from "./Components/AccountSummaryCard/AccountSummaryCard";
export interface StyledButtonProps {
  background?: string;
  textcolor?: string;
  height?: string;
  width?: string;
}

export const Home = ({
  customerInfoLoading,
  getbillingDetails,
  graphQLError,
  error,
  getCustomerContact,
  billingLoading,
  billingError,
  troubleTicketStatusLoading,
  outageDetailsLoading,
  billingDetails,
  plansServicesInfo,
  ordersLoading,
  tpLinkData,
  loadingState,
  upgradeBannerData,
  showCTFBanner,
  handleOrderUpgradeRoute,
  plansServicesLoading,
  autopayPaperlessLoading,
  loader,
  getAvailableSlotsDetailsLoading,
  reasonCodesForTTLoading,
}: any) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [bannerClose, setBannerClose] = useState<boolean>(true);
  const customerDetails = useSelector((state: any) => state.customerInfoDetails);
  const {
    autopayAmount,
    showAutopay,
    isNewCustomer,
    isSMB,
    showAutopayDiscountMessage,
    ziplyPlanName,
  } = useSelector((state: any) => state.customerPlanDetails);
  const { speedTestEligible, networkHealth, enableOwnRouterTest } = useSelector(
    (state: any) => state.networkStatusDetails.determineNetworkStatusDetails
  );
  const { scrollPosition } = useSelector((state: any) => state.pageInfo);
  const { paymentWarning } = useSelector((state: any) => state?.userInfo);
  const isFiberFirstCustomer =
    localStorage.getItem("acquiredCompany")?.trim().toLowerCase() === FIBERFIRST_ACQUIRED_COMPANY;
  const { isZiplyRouter, TpLinkError, isHigherGigPlan } = useSelector(
    (state: any) => state.networkStatusDetails
  );
  const orderDetails = useSelector((state: any) => state.customerInfoDetails.orderDetails);
  const { orderDetailsApiError } = useSelector((state: any) => state.orderDetails);
  const { autoPayData } = useSelector((state: any) => state?.autopayPaperlessDetails);
  const { troubleTicketDetails, troubleTicketApiError } = useSelector(
    (state: any) => state.troubleTicketDetails
  );
  const { activeAccount } = useSelector((state: any) => state?.customerInfoDetails);
  const {
    returnRequired: equipmentReturnRequired,
    status: equipmentReturnStatus,
    apiError: equipmentReturnApiError,
  } = useSelector((state: any) => state?.equipmentReturnDetails);
  const customerName = customerDetails?.givenNameFamilyName?.givenName;
  const envFlags = useSelector((state: any) => state?.userInfo?.envFlags);
  const sideCoreBannerMessages = useSelector(
    (state: any) => state?.sideCoreContent?.bannerMessages
  );
  const CTF_BANNER_MESSAGE = getBannerMessageByKey("ctf-upgrade", sideCoreBannerMessages);
  const WIFI7_UPGRADE_BANNER_MESSAGE = getBannerMessageByKey(
    "wifi7-upgrade",
    sideCoreBannerMessages
  );
  const AUTOPAY_SETUP_BANNER_MESSAGE = getBannerMessageByKey(
    "autopay-setup",
    sideCoreBannerMessages
  );
  const LOVE_YOUR_INTERNET_BANNER_MESSAGE = getBannerMessageByKey(
    "love-your-internet",
    sideCoreBannerMessages
  );
  const ACCOUNT_ACTIVATION_BANNER_MESSAGE = getBannerMessageByKey(
    "account-activation",
    sideCoreBannerMessages
  );
  const NETWORK_ISSUE_BANNER_MESSAGE = getBannerMessageByKey(
    "network-issue-detected",
    sideCoreBannerMessages
  );
  const NON_ZIPLY_ROUTER_BANNER_MESSAGE = getBannerMessageByKey(
    "non-ziply-router",
    sideCoreBannerMessages
  );
  const FIBERFIRST_BANNER = getBannerMessageByKey(
    FIBERFIRST_BANNER_KEY,
    sideCoreBannerMessages,
    false
  );
  const NETWORK_STATUS = getFlags("network_status_v2", envFlags);
  const TP_LINK_BANNER = getFlags("show_tplink_banner", envFlags);
  const INACTIVE_ACCOUNTS = getFlags("inactive_accounts", envFlags);
  const TROUBLE_TICKET_TRACKER = getFlags("show_troubleTicketTracker", envFlags);
  const GLOBAL_BANNER = getFlags("show_global_banner", envFlags);
  const ORDER_TRACKER = getFlags("show_orderTracker", envFlags);
  const WIFI7_BANNER = getFlags("wifi7_banner", envFlags);
  const AUTOPAY_BANNER = getFlags("enable_autopay_banner", envFlags);
  const ENABLE_RETURN_EQUIPMENT = getFlags("enable_return_equipment", envFlags);
  const hasOpenOrder = orderDetails && Object.keys(orderDetails)?.length > 0;
  const isDisconnectedOrder =
    orderDetails &&
    Object.keys(orderDetails)?.length > 0 &&
    orderDetails?.orderType === "disconnect";
  const hideInactiveFeature = INACTIVE_ACCOUNTS ? activeAccount !== false : true;
  const showOrderTracker =
    !orderDetailsApiError &&
    !ordersLoading &&
    hasOpenOrder &&
    isDisconnectedOrder === false &&
    !customerInfoLoading;

  const tickets = troubleTicketDetails && troubleTicketDetails?.tickets;

  const getAppLink = () => {
    const userAgent = navigator.userAgent;

    if (/iPad|iPhone|iPod/.test(userAgent)) {
      return tpLinkData?.verifyTPLinkRouter?.tpLinkApple;
    } else if (/android/i.test(userAgent)) {
      return tpLinkData?.verifyTPLinkRouter?.tpLinkAndroid;
    } else {
      return tpLinkData?.verifyTPLinkRouter?.tpLinkURL;
    }
  };

  const showTpLinkOnly = tpLinkData?.verifyTPLinkRouter?.wifi7 && getAppLink() && !TpLinkError;
  const tpLinkMessage = splitMessageBybraces(tpLinkData?.verifyTPLinkRouter?.message);
  const tpLinkBannerContent = {
    title: tpLinkMessage[0],
    description: tpLinkMessage[1],
    linkText: tpLinkMessage[2],
    link: getAppLink(),
  };
  const showWifiBanner = tpLinkData?.verifyTPLinkRouter?.showUpgradeRouter;
  const showPaymentWarningBanner =
    GLOBAL_BANNER &&
    paymentWarning &&
    Object.keys(paymentWarning).length > 0 &&
    paymentWarning?.error &&
    paymentWarning?.allScreens &&
    paymentWarning?.message;

  const showHideAutopayBanner =
    !showAutopay &&
    !billingLoading &&
    hideInactiveFeature &&
    !billingError &&
    !loader &&
    !graphQLError &&
    customerDetails?.accountNumber;

  const showAutopayBanner =
    AUTOPAY_BANNER &&
    !isSMB &&
    showAutopayDiscountMessage &&
    !billingLoading &&
    !isNewCustomer &&
    customerDetails?.accountNumber &&
    hideInactiveFeature &&
    autoPayData &&
    showAutopay &&
    Object.keys(autoPayData)?.length === 0 &&
    !loader;

  const showCTFBannerOnly = showCTFBanner && hideInactiveFeature;

  const showWifi7BannerOnly = WIFI7_BANNER && showWifiBanner;

  const showInactiveBanner =
    INACTIVE_ACCOUNTS &&
    activeAccount === false &&
    !customerInfoLoading &&
    !billingLoading &&
    customerDetails?.linkedAccountNumbers?.length > 0 &&
    !graphQLError;
  const showEquipmentReturnBanner =
    ENABLE_RETURN_EQUIPMENT &&
    equipmentReturnRequired &&
    equipmentReturnStatus?.toLowerCase() === "pending" &&
    !equipmentReturnApiError;

  const chatWithAgent = () => {
    window.slowSpeeedDetected("D582223DCFE61", {
      accountNumber: customerDetails?.accountNumber,
      plan: ziplyPlanName,
      serviceArea: isSMB ? "Business" : "Residential",
      serviceStatus: "inActive",
      connectionStatus: "Unstable Signal Detected",
    });
  };

  const handleToAutopay = () => {
    navigate("/billing/signupautopay", {
      state: {
        NavigateToHome: true,
      },
    });
  };

  const paymentWarningMessage = {
    paymentMessage: paymentWarning?.message,
  };
  const refreshCustomerContact = () => {
    getCustomerContact();
  };
  const handleBanner = () => {
    setBannerClose(false);
  };
  const navigateToUpgrade = () => {
    navigate("/account/upgrade-speed");
  };
  const handleShareZiply = () => {
    window.open("https://referafriend.ziplyfiber.com/", "_blank");
  };

  useEffect(() => {
    dispatch(setCheckRouterTypeError(false));
  }, []);

  useEffect(() => {
    const USIValue = readCookie("customerUSI");
    const tokenVal = readCookie("Token");

    if (USIValue && tokenVal) {
      if (window.loginCompleted !== undefined) {
        window.loginCompleted();
      }
    }
  }, []);

  return (
    <>
      <Box minHeight={"95vh"}>
        <PageGrid container>
          <Grid item lg={8.3} xs={12}>
            {customerDetails?.linkedAccountNumbers?.length > 0 &&
              !customerInfoLoading &&
              hideInactiveFeature && (
                <WelcomeHeading>
                  {WELCOME_BACK}
                  {customerName ? `, ${customerName}` : ""}!
                </WelcomeHeading>
              )}
            {isFiberFirstCustomer && <FiberFirstBanner banner={FIBERFIRST_BANNER} />}
            <Box sx={{ mt: 3 }}>
              {showPaymentWarningBanner && (
                <ImportantUpdatesBanner content={paymentWarningMessage} />
              )}
              {showHideAutopayBanner && (
                <HomepageNewBanners content={ACCOUNT_ACTIVATION_BANNER_MESSAGE?.content} />
              )}
              {showAutopayBanner && (
                <HomepageNewBanners content={AUTOPAY_SETUP_BANNER_MESSAGE?.content} />
              )}
              {showCTFBannerOnly && <HomepageNewBanners content={CTF_BANNER_MESSAGE?.content} />}
              {showWifi7BannerOnly && (
                <HomepageNewBanners content={WIFI7_UPGRADE_BANNER_MESSAGE?.content} />
              )}
              {showInactiveBanner && <InactiveAccountBanner />}
            </Box>
            {ORDER_TRACKER && hideInactiveFeature && showOrderTracker && (
              <TrackOrder orderDetails={orderDetails} orderDetailsLoading={false} />
            )}
            {customerDetails?.linkedAccountNumbers?.length > 0 &&
            !customerInfoLoading &&
            hideInactiveFeature ? (
              <>
                {TROUBLE_TICKET_TRACKER && tickets?.length > 0 && !troubleTicketApiError && (
                  <TroubleTicketStatus troubleTicketStatusLoading={troubleTicketStatusLoading} />
                )}

                {/* <CardHeading>Total balance</CardHeading> */}
                <AccountSummaryCard
                  billingLoading={billingLoading}
                  autopayPaperlessLoading={autopayPaperlessLoading}
                  billingError={billingError}
                  getbillingDetails={getbillingDetails}
                />
              </>
            ) : customerDetails?.linkedAccountNumbers?.length === 0 &&
              !customerInfoLoading &&
              !error &&
              !graphQLError ? (
              orderDetails && Object.keys(orderDetails)?.length !== 0 ? (
                <>
                  <StyledCard sx={{ py: 10, pb: 15 }}>
                    <LinkingWaitMessage />
                  </StyledCard>
                </>
              ) : (
                <>
                  <BlankPage />
                </>
              )
            ) : error || graphQLError ? (
              <Box my={20}>
                <ErrorComponent onRefresh={refreshCustomerContact} />
              </Box>
            ) : null}
            {showEquipmentReturnBanner && <EquipmentReturnPendingBanner />}
            {TP_LINK_BANNER &&
              hideInactiveFeature &&
              showTpLinkOnly &&
              loadingState &&
              !customerInfoLoading && <ImportantUpdatesBanner content={tpLinkBannerContent} />}

            {NETWORK_STATUS && (
              <>
                {isZiplyRouter === false && enableOwnRouterTest && speedTestEligible && (
                  <HomepageNewBanners
                    content={NON_ZIPLY_ROUTER_BANNER_MESSAGE?.content}
                    bannerType="warning"
                    actionItemStyles={{
                      color: Theme.palette.customcolor.whiteColor,
                      textDecoration: "none",
                      background: Theme.palette.secondary.main,
                      border: "none",
                      cursor: "pointer",
                    }}
                    actionItem={"UPGRADE TO ZIPLY ROUTER"}
                    onActionHandle={navigateToUpgrade}
                  />
                )}

                {networkHealth && isHigherGigPlan && !billingLoading && <NetworkHealthBanner />}

                {speedTestEligible &&
                  activeAccount !== false &&
                  !billingLoading &&
                  !isHigherGigPlan && (
                    <>
                      {networkHealth &&
                      ((isZiplyRouter === false && enableOwnRouterTest) || isZiplyRouter) ? (
                        <>
                          <NetworkTest />
                        </>
                      ) : (
                        ((isZiplyRouter === false && enableOwnRouterTest) || isZiplyRouter) && (
                          <HomepageNewBanners
                            content={NETWORK_ISSUE_BANNER_MESSAGE?.content}
                            actionItem={"CHAT WITH AGENT"}
                            actionItemStyles={{
                              color: Theme.palette.customcolor.whiteColor,
                              textDecoration: "none",
                              background: Theme.palette.secondary.main,
                              border: "none",
                              cursor: "pointer",
                            }}
                            onActionHandle={() => chatWithAgent()}
                            bannerType="error"
                          />
                        )
                      )}
                    </>
                  )}
              </>
            )}

            <HomepageNewBanners
              content={LOVE_YOUR_INTERNET_BANNER_MESSAGE?.content}
              actionItem={HOMEPAGE_BANNER_SHARE_ZIPLY_BUTTON}
              onActionHandle={handleShareZiply}
              bannerType={"info"}
            />
          </Grid>

          <Grid
            item
            xs={12}
            lg={3.5}
            display={{ xs: "block", lg: scrollPosition > 15 ? "block" : "none" }}>
            <AccountCard />
            <NeedHelpCard />
          </Grid>
        </PageGrid>

        <StickyBox display={{ xs: "none", lg: scrollPosition > 15 ? "none" : "block" }}>
          <AccountCard />
          <NeedHelpCard />
        </StickyBox>
      </Box>
    </>
  );
};
